module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Settings4-aa1c107ae7ad62b1895c6f1d09c2cd3d.svg";